<template>
  <div v-if="!editMode">
    <p class="mb-1">
      {{ localValue }}
    </p>
    <div class="hvh-flex controls">
      <span class="posted mr-3">Posted: 01/27/2022</span>
      <span class="link mr-3" @click="remove">Delete</span>
      <span class="link" @click="editMode = true">Edit</span>
    </div>
  </div>
  <div v-else>
    <textarea class="spcore-textarea w-100" :value="localValue" rows="6" @input="localValue = $event.target.value" />
    <div class="hvh-flex end">
      <v-btn flat large class="hvh-btn hvh-btn--primary mr-0" @click="finish">Finish</v-btn>
    </div>
    <!-- <v-btn class="my-1 mx-2" flat black>Finish</v-btn> -->
  </div>
</template>

<script>
export default {
  noExport: true,
  props: ['value'],
  data() {
    return {
      editMode: false,
      localValue: this.value,
    };
  },
  methods: {
    finish() {
      this.$emit('input', this.localValue);
      this.editMode = false;
    },
    remove() {
      this.$confirm('Delete input', 'Are you sure you want to deleete input?')
        .then(() => this.$emit('delete'))
        .catch(() => null);
    },
  },
  watch: {
    value() {
      this.localValue = this.value;
    },
  },
}
</script>

<style lang="scss" scoped>
.posted {
  color: #676a6d;
}

.link {
  color: #002f6c;
  text-decoration: underline #002f6c;
  cursor: pointer;
}

p {
  color: #181815;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 21px;
}

.controls {
  font-size: 10px;
}
</style>